import { getData, postData, putData, deleteData } from "../apiClient";

// get role data with pagination
export const getRolesWithPagination = async (
  { page = 1, limit = 10, search = "" },
  signal = null,
) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/role/get/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get roles with pagination API error:", error);
    return {
      success: false,
      ...error,
    };
  }
};

// get role data with id
export const getRoleDataWithId = async (id) => {
  try {
    const result = await getData(`role/getOne/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get role data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// create role
export const createRole = async ({ data }) => {
  try {
    const result = await postData(`/role/create`, data);
    console.log("🚀 ~ createRole ~ result:", result)

    return {
      data: {
        success: true,
        message: result.message,
        data: result,
      },
    };
  } catch (error) {
    console.error(
      "Role add API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        message: error.message,
        status: error.status,
      },
    };
  }
};

// delete role
export const deleteRole = async ({ id }) => {
  try {
    const result = await deleteData(`role/delete/${id}`);
    return {
      data: {
        message: result.message,
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Delete role API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// update role data
export const updateRole = async ({ id, data }) => {
  try {
    const result = await putData(`/role/update/${id}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Update user API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};
